/**
 * Countries for activities held abroad (diaspora, international meetings): ISO 3166-1 alpha-2
 * code and Albanian name, Albania excluded. Generated once from ICU (Node, locale "sq") and kept
 * static so the names never depend on the browser. Kosovo is "XK".
 */
export const COUNTRIES = [
    ['AF', 'Afganistan'],
    ['ZA', 'Afrika e Jugut'],
    ['DZ', 'Algjeri'],
    ['AD', 'Andorrë'],
    ['AO', 'Angolë'],
    ['AI', 'Anguilë'],
    ['AG', 'Antigua e Barbuda'],
    ['SA', 'Arabi Saudite'],
    ['AR', 'Argjentinë'],
    ['AM', 'Armeni'],
    ['AW', 'Arubë'],
    ['AU', 'Australi'],
    ['AT', 'Austri'],
    ['AZ', 'Azerbajxhan'],
    ['BS', 'Bahama'],
    ['BH', 'Bahrejn'],
    ['BD', 'Bangladesh'],
    ['BB', 'Barbados'],
    ['BE', 'Belgjikë'],
    ['BZ', 'Belizë'],
    ['BJ', 'Benin'],
    ['BM', 'Bermude'],
    ['BY', 'Bjellorusi'],
    ['BO', 'Bolivi'],
    ['BA', 'Bosnjë-Hercegovinë'],
    ['BW', 'Botsvanë'],
    ['BR', 'Brazil'],
    ['BN', 'Brunei'],
    ['BG', 'Bullgari'],
    ['BF', 'Burkina-Faso'],
    ['BI', 'Burundi'],
    ['BT', 'Butan'],
    ['CI', "Côte d'Ivoire"],
    ['TD', 'Çad'],
    ['CZ', 'Çeki'],
    ['DK', 'Danimarkë'],
    ['DM', 'Dominikë'],
    ['EG', 'Egjipt'],
    ['EC', 'Ekuador'],
    ['AE', 'Emiratet e Bashkuara Arabe'],
    ['ER', 'Eritre'],
    ['EE', 'Estoni'],
    ['SZ', 'Esvatini'],
    ['ET', 'Etiopi'],
    ['PH', 'Filipine'],
    ['FI', 'Finlandë'],
    ['FJ', 'Fixhi'],
    ['FR', 'Francë'],
    ['GA', 'Gabon'],
    ['GM', 'Gambi'],
    ['GH', 'Ganë'],
    ['GG', 'Gernsej'],
    ['GD', 'Granadë'],
    ['GR', 'Greqi'],
    ['GL', 'Grënlandë'],
    ['GP', 'Guadelupë'],
    ['GF', 'Guajana Franceze'],
    ['GY', 'Guajanë'],
    ['GU', 'Guam'],
    ['GT', 'Guatemalë'],
    ['GN', 'Guine'],
    ['GW', 'Guine-Bisau'],
    ['PG', 'Guineja e Re-Papua'],
    ['GQ', 'Guineja Ekuatoriale'],
    ['GE', 'Gjeorgji'],
    ['DE', 'Gjermani'],
    ['GI', 'Gjibraltar'],
    ['HT', 'Haiti'],
    ['NL', 'Holandë'],
    ['HN', 'Honduras'],
    ['HU', 'Hungari'],
    ['IN', 'Indi'],
    ['ID', 'Indonezi'],
    ['IQ', 'Irak'],
    ['IR', 'Iran'],
    ['IE', 'Irlandë'],
    ['IS', 'Islandë'],
    ['AX', 'Ishujt Alandë'],
    ['MP', 'Ishujt e Marianës Veriore'],
    ['VG', 'Ishujt e Virgjër Britanikë'],
    ['VI', 'Ishujt e Virgjër të SHBA-së'],
    ['FK', 'Ishujt Falkland'],
    ['FO', 'Ishujt Faroe'],
    ['KY', 'Ishujt Kajman'],
    ['CK', 'Ishujt Kuk'],
    ['MH', 'Ishujt Marshall'],
    ['SB', 'Ishujt Solomon'],
    ['TC', 'Ishujt Turks dhe Kaikos'],
    ['IM', 'Ishulli i Manit'],
    ['NF', 'Ishulli Norfolk'],
    ['IT', 'Itali'],
    ['IL', 'Izrael'],
    ['JP', 'Japoni'],
    ['YE', 'Jemen'],
    ['JO', 'Jordani'],
    ['NC', 'Kaledoni e Re'],
    ['KH', 'Kamboxhia'],
    ['CM', 'Kamerun'],
    ['CA', 'Kanada'],
    ['BQ', 'Karaibet holandeze'],
    ['QA', 'Katar'],
    ['KZ', 'Kazakistan'],
    ['KE', 'Kenia'],
    ['CV', 'Kepi i Gjelbër'],
    ['CL', 'Kili'],
    ['CN', 'Kinë'],
    ['KG', 'Kirgizi'],
    ['KI', 'Kiribati'],
    ['CO', 'Kolumbi'],
    ['KM', 'Komore'],
    ['CG', 'Kongo-Brazavilë'],
    ['CD', 'Kongo-Kinshasa'],
    ['KR', 'Kore e Jugut'],
    ['KP', 'Kore e Veriut'],
    ['XK', 'Kosovë'],
    ['CR', 'Kosta-Rikë'],
    ['HR', 'Kroaci'],
    ['CU', 'Kubë'],
    ['CW', 'Kurasao'],
    ['KW', 'Kuvajt'],
    ['LA', 'Laos'],
    ['LS', 'Lesoto'],
    ['LV', 'Letoni'],
    ['LB', 'Liban'],
    ['LR', 'Liberi'],
    ['LY', 'Libi'],
    ['LI', 'Lihtenshtajn'],
    ['LT', 'Lituani'],
    ['LU', 'Luksemburg'],
    ['MG', 'Madagaskar'],
    ['YT', 'Majotë'],
    ['ME', 'Mal i Zi'],
    ['MY', 'Malajzi'],
    ['MW', 'Malavi'],
    ['MV', 'Maldive'],
    ['ML', 'Mali'],
    ['MT', 'Maltë'],
    ['MK', 'Maqedonia e Veriut'],
    ['MA', 'Marok'],
    ['MQ', 'Martinikë'],
    ['MR', 'Mauritani'],
    ['MU', 'Mauritius'],
    ['GB', 'Mbretëria e Bashkuar'],
    ['MX', 'Meksikë'],
    ['MM', 'Mianmar (Burmë)'],
    ['FM', 'Mikronezi'],
    ['MD', 'Moldavi'],
    ['MC', 'Monako'],
    ['MN', 'Mongoli'],
    ['MS', 'Montserat'],
    ['MZ', 'Mozambik'],
    ['NA', 'Namibi'],
    ['NR', 'Nauru'],
    ['NP', 'Nepal'],
    ['NE', 'Niger'],
    ['NG', 'Nigeri'],
    ['NI', 'Nikaragua'],
    ['NU', 'Niue'],
    ['NO', 'Norvegji'],
    ['OM', 'Oman'],
    ['PK', 'Pakistan'],
    ['PW', 'Palau'],
    ['PA', 'Panama'],
    ['PY', 'Paraguai'],
    ['PE', 'Peru'],
    ['PF', 'Polinezia Franceze'],
    ['PL', 'Poloni'],
    ['PR', 'Porto-Riko'],
    ['PT', 'Portugali'],
    ['CY', 'Qipro'],
    ['DO', 'Republika Dominikane'],
    ['CF', 'Republika e Afrikës Qendrore'],
    ['RE', 'Reunion'],
    ['HK', 'RPA i Hong-Kongut'],
    ['MO', 'RPA i Makaos'],
    ['RW', 'Ruandë'],
    ['RO', 'Rumani'],
    ['RU', 'Rusi'],
    ['EH', 'Saharaja Perëndimore'],
    ['SV', 'Salvador'],
    ['WS', 'Samoa'],
    ['AS', 'Samoa Amerikane'],
    ['SM', 'San-Marino'],
    ['ST', 'Sao-Tome e Principe'],
    ['SC', 'Sejshelle'],
    ['BL', 'Sen-Bartelemi'],
    ['MF', 'Sen-Marten'],
    ['SN', 'Senegal'],
    ['RS', 'Serbi'],
    ['SL', 'Sierra-Leone'],
    ['SG', 'Singapor'],
    ['SX', 'Sint-Marten'],
    ['SY', 'Siri'],
    ['SK', 'Sllovaki'],
    ['SI', 'Slloveni'],
    ['SO', 'Somali'],
    ['ES', 'Spanjë'],
    ['LK', 'Sri-Lankë'],
    ['SD', 'Sudan'],
    ['SS', 'Sudani i Jugut'],
    ['SE', 'Suedi'],
    ['SR', 'Surinami'],
    ['SJ', 'Svalbard e Jan-Majen'],
    ['US', 'SHBA'],
    ['SH', 'Shën-Elenë'],
    ['KN', 'Shën-Kits dhe Nevis'],
    ['LC', 'Shën-Luçia'],
    ['PM', 'Shën-Pier dhe Mikelon'],
    ['VC', 'Shën-Vincent dhe Grenadine'],
    ['TH', 'Tajlandë'],
    ['TW', 'Tajvan'],
    ['TZ', 'Tanzani'],
    ['TJ', 'Taxhikistan'],
    ['PS', 'Territoret Palestineze'],
    ['TL', 'Timor-Leste'],
    ['TG', 'Togo'],
    ['TK', 'Tokelau'],
    ['TO', 'Tonga'],
    ['TT', 'Trinidad e Tobago'],
    ['TN', 'Tunizi'],
    ['TM', 'Turkmenistan'],
    ['TR', 'Turqi'],
    ['TV', 'Tuvalu'],
    ['UG', 'Ugandë'],
    ['UA', 'Ukrainë'],
    ['WF', 'Uollis e Futuna'],
    ['UY', 'Uruguai'],
    ['UZ', 'Uzbekistan'],
    ['VU', 'Vanuatu'],
    ['VA', 'Vatikan'],
    ['VE', 'Venezuelë'],
    ['VN', 'Vietnam'],
    ['JM', 'Xhamajkë'],
    ['JE', 'Xhersej'],
    ['DJ', 'Xhibuti'],
    ['ZM', 'Zambi'],
    ['NZ', 'Zelandë e Re'],
    ['ZW', 'Zimbabve'],
    ['CH', 'Zvicër'],
];
export const COUNTRY_CODES = COUNTRIES.map(([code]) => code);
const byCode = new Map(COUNTRIES.map(([code, name]) => [code, name]));
/** Albanian name of a country code; the code itself if unknown. */
export const countryName = (code) => byCode.get(code) ?? code;
//# sourceMappingURL=countries.js.map